(() => {
  if (!document.querySelector('[data-avant-cart-page]')) return;
  const routes = Object.assign({ cart_url: '/cart', cart_change_url: '/cart/change', cart_update_url: '/cart/update' }, window.routes || {});
  let pending = false;
  const currentRoot = () => document.querySelector('[data-avant-cart-page]');
  const setBusy = (busy) => {
    pending = busy;
    const root = currentRoot();
    if (root) root.setAttribute('aria-busy', String(busy));
    const checkout = root?.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = busy || !window.AvantDeliveryDate;
  };
  const replacePage = async () => {
    const response = await fetch(routes.cart_url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('Unable to refresh your cart.');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = page.querySelector('[data-avant-cart-page]');
    const previous = currentRoot();
    const note = previous?.querySelector('[name="note"]')?.value;
    const date = previous?.querySelector('[data-delivery-date]')?.value;
    if (fresh && previous) {
      previous.replaceWith(fresh);
      window.AvantDeliveryDate?.init();
      if (note !== undefined && fresh.querySelector('[name="note"]')) fresh.querySelector('[name="note"]').value = note;
      if (date !== undefined && fresh.querySelector('[data-delivery-date]')) {
        fresh.querySelector('[data-delivery-date]').value = date;
        window.AvantDeliveryDate?.validate(fresh.querySelector('#AvantCartForm'));
      }
    }
    setBusy(false);
  };
  const changeLine = async (key, quantity) => {
    if (pending || !key) return;
    setBusy(true);
    try {
      const response = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Unable to update your cart.');
      await window.AvantCart?.refresh();
      await replacePage();
    } catch (error) { setBusy(false); window.alert(error.message); }
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-avant-cart-page]')) return;
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      const line = remove.closest('[data-cart-line]');
      if (line) changeLine(line.dataset.cartKey, 0);
      return;
    }
    const control = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!control) return;
    const input = control.closest('[data-quantity]')?.querySelector('[data-quantity-input]');
    if (!input) return;
    const delta = control.hasAttribute('data-quantity-plus') ? 1 : -1;
    changeLine(input.dataset.cartKey, Math.max(0, (parseInt(input.value, 10) || 0) + delta));
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-avant-cart-page] [data-quantity-input]');
    if (input) changeLine(input.dataset.cartKey, Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('#AvantCartForm');
    if (!form) return;
    if (pending) { event.preventDefault(); return; }
    if (event.submitter?.name === 'checkout') {
      if (!window.AvantDeliveryDate?.validate(form, true)) event.preventDefault();
      return;
    }
    event.preventDefault();
    const updates = {};
    form.querySelectorAll('[data-quantity-input]').forEach((input) => {
      updates[input.dataset.cartKey] = Math.max(0, parseInt(input.value, 10) || 0);
    });
    setBusy(true);
    try {
      const date = form.querySelector('[data-delivery-date]')?.value || '';
      const attributes = !date || window.AvantDeliveryDate?.validate(form)
        ? { date: window.AvantDeliveryDate?.legacy(date) || '' } : undefined;
      const response = await fetch(`${routes.cart_update_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, note: form.querySelector('[name="note"]')?.value || '', attributes }),
      });
      if (!response.ok) throw new Error('Unable to update your cart.');
      await window.AvantCart?.refresh();
      await replacePage();
    } catch (error) { setBusy(false); window.alert(error.message); }
  });
})();
